<template>
  <div v-bind:class="{ 'modal-container': true, show: show }">
    <div class="modal-content">
      <div class="shift-form" v-if="gap !== null && driver !== null && sector !== null">
        <div class="form-title">
          <span class="highlight">{{ gap.start.format('MMM DD') }}</span>
          <span>SHIFT FOR</span>
          <span class="highlight">{{ sector.name }}</span>
        </div>

        <div class="time-picker">
          <label>START TIME FOR THE SHIFT:</label>
          <span class="inline selection">
            <div class="control" @click="setHour(true)"><i class="fa fa-chevron-up"></i></div>
            <div class="value">{{ timeHour < 10 ? '0' + timeHour :  timeHour }}</div>
            <div class="control" @click="setHour(false)"><i class="fa fa-chevron-down"></i></div>
          </span>
          <span class="inline separator">:</span>
          <span class="inline selection">
            <div class="control" @click="setMinute(true)"><i class="fa fa-chevron-up"></i></div>
            <div class="value">{{ timeMinute < 10 ? '0' + timeMinute : timeMinute }}</div>
            <div class="control" @click="setMinute(false)"><i class="fa fa-chevron-down"></i></div>
          </span>
          <span class="inline separator">:</span>
          <span class="inline selection">
            <div class="control" @click="setAmPm"><i class="fa fa-chevron-up"></i></div>
            <div class="value">{{ timeAmPm }}</div>
            <div class="control" @click="setAmPm"><i class="fa fa-chevron-down"></i></div>
          </span>
        </div>

        <div class="field-input shift-duration">
          <label>DURATION FOR THE SHIFT:</label>
          <select v-model.number="shiftDuration">
            <option v-for="n in durationRange" :value="n">{{ n + (n > 1 ? ' hours' : ' hour')}}</option>
          </select>
        </div>

        <div class="row controls" v-show="!submitting">
          <div class="small-4 columns padding-R">
            <a class="button cta xsmall block secondary" href="javascript:;" @click="close">CANCEL</a>
          </div>
          <div class="small-8 columns padding-L">
            <a class="button cta xsmall block" href="javascript:;" @click="sendShift">SEND SHIFT TO {{ driver.firstName }}</a>
          </div>
        </div>

        <div class="notice" v-show="submitting">
          <div v-show="!done">
            <i class="fa fa-spinner fa-spin fa-lg"></i>
            <span>Sending shift to {{ driver.firstName }}...</span>
          </div>
          <div class="success" v-show="done && success">
            <i class="fa fa-check-circle fa-lg"></i>
            <span>Sent shift to {{ driver.firstName }}!</span>
          </div>
          <div class="fail" v-show="done && !success">
            <i class="fa fa-exclamation-triangle fa-lg"></i>
            <span>{{ errorMessage }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
export default {
  name: 'coverage-shift-form',
  data () {
    return {
      timeHour: 1,
      timeMinute: 0,
      timeAmPm: 'AM',
      durationRange: 12,
      shiftDuration: 10,
      submitting: false,
      done: false,
      success: false,
      errorMessage: 'Oops. Something went wrong. Please try again later.'
    }
  },
  computed: {
    show () { return this.$store.state.coverage.shiftForm.show },
    driver () { return this.$store.state.coverage.shiftForm.driver },
    gap () { return this.$store.state.coverage.shiftForm.gap },
    sector () { return this.$store.state.coverage.shiftForm.sector }
  },
  methods: {
    sendShift () {
      let self = this

      let dayStr = self.gap.start.format('MM/DD/YYYY')
      let timeHour = self.timeHour < 10 ? '0' + self.timeHour : '' + self.timeHour
      let timeMinute = self.timeMinute < 10 ? '0' + self.timeMinute : '' + self.timeMinute
      let timeAmPm = self.timeAmPm
      let startStr = dayStr + ' ' + timeHour + ':' + timeMinute + ':00' + timeAmPm
      let shiftStart = moment(startStr, 'MM/DD/YYYY hh:mm:ssA')
      let shiftEnd = moment(startStr, 'MM/DD/YYYY hh:mm:ssA').add(self.shiftDuration, 'hours')

      let request = {
        token: self.$store.state.session.sessionToken,
        driverId: self.driver.driverId,
        driverHomeSectorId: null,
        driverHomeSubsectorId: null,
        driverWorkSectorId: self.sector.ID,
        driverWorkSubsectorId: null,
        startTimestamp: shiftStart.unix(),
        endTimestamp: shiftEnd.unix(),
        driverConfirmed: 0
      }

      self.submitting = true
      self.done = false
      self.success = false

      self.$sdk.post('/shifts', request, r => {
        self.done = true

        if (r.error) {
          self.success = false
          self.errorMessage = r.error.message
        } else {
          self.success = true
        }

        setTimeout(() => {
          self.close()
        }, 1000)
      })
    },
    close () {
      this.$store.commit('coverage/setCoverageShiftFormShow', false)
      this.$store.commit('coverage/setCoverageShiftFormDriver', null)
      this.$store.commit('coverage/setCoverageShiftFormGap', null)
      this.$store.commit('coverage/setCoverageShiftFormSector', null)
    },
    setAmPm () {
      let value = 'AM'
      if (this.timeAmPm === 'AM') {
        value = 'PM'
      }
      this.timeAmPm = value
    },
    setHour (add) {
      let self = this
      let hour = self.timeHour

      if (add) {
        let value = hour + 1
        if (hour === 12) {
          value = 1
        }
        self.timeHour = value
        return
      }

      let value = hour - 1
      if (hour === 1) {
        value = 12
      }
      self.timeHour = value
    },
    setMinute (add) {
      let self = this
      let minute = self.timeMinute

      if (add) {
        let value = minute + 5
        if (minute === 55) {
          value = 0
        }
        self.timeMinute = value
        return
      }

      let value = minute - 5
      if (minute === 0) {
        value = 55
      }
      self.timeMinute = value
    },
  },
  watch: {
    gap (value) {
      if (value === null) {
        return
      }

      let self = this
      self.submitting = false
      self.done = false
      self.success = false
      self.timeHour = parseInt(self.gap.start.format('hh'))
      self.timeMinute = parseInt(self.gap.start.format('mm'))
      self.timeAmPm = self.gap.start.format('A')
    }
  }
}
</script>

<style lang="scss" scoped>
.modal-container {
  position: fixed;
  display: table;
  top: -100%;
  left: 0;
  opacity: 0;
  width: 100%;
  height: 100%;
  z-index: 12;
  background-color: rgba(0,0,0,0.5);
  transition: all 250ms;

  &.show {
    top: 0;
    opacity: 1;
  }
}

.modal-content {
  display: table-cell;
  vertical-align: middle;
}

.shift-form {
  background-color: #fff;
  border-radius: 5px;
  width: 300px;
  margin: 0 auto;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0,0,0,0.35);
}
.form-title {
  text-transform: uppercase;
  text-align: center;
  padding: 10px 10px;
  border-bottom: 1px solid rgba(0,0,0,0.3);
  margin-bottom: 10px;
  font-size: 14px;
  background-color: #333;
  color: #e5e5e5;

  & > * {
    display: inline-block;
    vertical-align: middle;
  }

  & .highlight {
    font-weight: 700;
    color: #fff;
  }
}
.time-picker {
  width: 100%;
  padding: 0 15px;
  height: 90px;
  & label {
    color: #0D79F2;
    font-weight: 700;
    font-size: 10px;
    line-height: 10px;
    display: block;
    margin-bottom: 10px;
  }

  & .inline {
    display: inline-block;
    vertical-align: middle;
    float: left;
    text-align: center;
  }
  & .selection {
    text-align: center;
    width: 30%;

    & .value {
      font-size: 22px;
      font-weight: 700;
      color: #555;
    }

    & .control {
      font-size: 12px;
      color: #0D79F2;
      cursor: pointer;
      width: 100%;
    }
  }

  & .separator {
    line-height: 69px;
    height: 69px;
    color: #777;
    padding: 0 5px;
    width: 5%;
  }
}
.field-input {
  padding: 5px 15px 15px;
  & label {
    color: #0D79F2;
    font-weight: 700;
    font-size: 10px;
    line-height: 10px;
  }

  select {
    font-size: 14px;
    height: 37px;
    outline: 0;
    padding: 7px 7px;
    display: block;
    border-color: rgba(0,0,0,0.15);
    background-color: #fff;
    border-radius: 3px;
  }
}
.controls {
  padding: 0 15px 15px;

  & .padding-L { padding-left: 5px; }
  & .padding-R { padding-right: 5px; }
}

.notice {
  padding: 9px 15px 24px;
  text-align: center;
  font-size: 14px;
  line-height: 14px;
  font-weight: 700;

  & > div > * {
    vertical-align: middle;
    display: inline-block;
  }
  & .success i { color: #26D97A; }
  & .fail i { color: #F25E0D; }
}

</style>



// WEBPACK FOOTER //
// src/components/Coverage/ShiftForm.vue